import { Link } from 'react-router-dom';
import { categories } from '@/mocks/mangas';

export default function CategorySection() {
  return (
    <section className="py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            漫画分类
          </h2>
          <p className="mt-2 text-sm text-foreground-600">
            日漫、韩漫、国漫，一键找到你喜欢的类型
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group relative overflow-hidden rounded-xl bg-background-100 p-6 md:p-8 transition-all hover:bg-background-200/70 cursor-pointer"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-500/10 flex items-center justify-center mb-4 group-hover:scale-110 transition-transform">
                <i className={`${cat.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-lg font-bold text-foreground-950 mb-2">{cat.name}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{cat.description}</p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-500">{cat.count} 部作品</span>
                <span className="text-sm text-primary-500 font-medium flex items-center gap-1 whitespace-nowrap">
                  进入 <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}